import { unitySearchParams } from '@@containers/Search/unitySearchParams';

export const userListSearchParams = unitySearchParams.pick({ q: true, page: true });
